// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zJC6{align-items:center;display:flex;gap:16px;justify-content:space-between;width:100%}.mGUR{align-items:center;display:inline-flex;gap:16px}._8Ej5{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.vV2N{color:var(--grey-400);font-family:\"Roboto\",sans-serif!important;font-size:14px;font-style:normal;font-weight:400;letter-spacing:.17px;line-height:20px}.th3r{grid-gap:12px;display:grid;gap:12px;grid-template-columns:repeat(5,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarAvatar": "zJC6",
	"actionSidebarAvatarToggle": "mGUR",
	"actionSidebarAvatarLabel": "_8Ej5",
	"actionSidebarAvatarDescription": "vV2N",
	"actionSidebarAvatarVariants": "th3r"
};
module.exports = ___CSS_LOADER_EXPORT___;
